export class ProposalProjectCostIT{
    constructor(id, proposalProject, detail, description, quantity, unit, period, type, origin){
        this.id = id;
        this.proposalProject = proposalProject;
        this.detail = detail;
        this.description = description;
        this.quantity = quantity;
        this.unit = unit;
        this.period = period;
        this.type = type;
        this.origin = origin;
    }
    static createFromResponseData(responseData){
        return new ProposalProjectCostIT(
            responseData.id,
            responseData.proposalProject,
            responseData.detail,
            responseData.description,
            responseData.quantity,
            responseData.unit,
            responseData.period,
            responseData.type,
            responseData.origin
        );
    }
};